export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.prooferp.svsnursingcollege&hl=en_IN";
export const IOS_URL =
  "https://apps.apple.com/us/app/svs-college-of-nursing/id6755893288";
